export default __webpack_public_path__ + "static/media/goshen38.859ea0c8.jpg";